// The history of the small panel (plan brain-conversacion-en-segundo-plano,
// 4.4): the title opens the latest conversations, as ChatGPT and Claude do, so
// going back to one does not mean leaving the page for the full Brain screen.
//
// The list is the same query as the full screen's sidebar, with the same
// «thinking» mark: one list, painted in two places.

import { useTranslation } from 'react-i18next'
import { ChevronDown, Loader2, Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { isThinking, useBrainConversationsQuery } from '@/queries/brain'

// Enough to go back to what was being done today; the rest is in the full
// screen, one click away.
const LATEST = 8

export function BrainHistoryMenu({
  activeThread,
  onOpen,
  onNew,
}: {
  activeThread: string
  onOpen: (thread: string) => void
  onNew: () => void
}) {
  const { t } = useTranslation()
  const latest = (useBrainConversationsQuery().data ?? []).slice(0, LATEST)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="xs" className="-ml-2 gap-1" aria-label={t('brain.historial')}>
          <span className="text-sm font-medium">{t('brain.title')}</span>
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72">
        <DropdownMenuItem onSelect={onNew} className="gap-2">
          <Plus className="h-4 w-4" />
          {t('brain.new_chat')}
        </DropdownMenuItem>
        {latest.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs font-normal text-muted-foreground">
              {t('brain.recientes')}
            </DropdownMenuLabel>
            {latest.map((c) => (
              <DropdownMenuItem
                key={c.thread_id}
                onSelect={() => onOpen(c.thread_id)}
                className={cn('gap-2', c.thread_id === activeThread && 'bg-muted font-medium')}
              >
                {isThinking(c) && (
                  <Loader2 className="h-3.5 w-3.5 shrink-0 animate-spin text-primary" aria-label={t('brain.thinking')} />
                )}
                <span className="truncate">{c.title || t('brain.conversacion_sin_titulo')}</span>
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
